function initializeScrollAnimationTrigger(rootEl = document) {
  /********************** MENU **********************/
  const btnMenu = document.querySelector('header .menu');
  const nav = document.querySelector('nav');

  if (!btnMenu && !nav) {
    const close = nav.querySelector('.close');
    const back = nav.querySelectorAll('.back');
    const niveau1 = nav.querySelectorAll('.toggle');
    const niveau2 = nav.querySelectorAll('.sous-menu');

    btnMenu.addEventListener('click', () => {
      nav.classList.add('active');
    });

    close.addEventListener('click', () => {
      niveau2.forEach((sousElement) => {
        sousElement.classList.remove('active');
      });
      nav.classList.remove('active');
    });

    back.forEach((element) => {
      element.addEventListener('click', () => {
        niveau2.forEach((sousElement) => {
          sousElement.classList.remove('active');
        });
      });
    });

    niveau1.forEach((element) => {
      element.addEventListener('click', () => {
        niveau2.forEach((sousElement) => {
          sousElement.classList.remove('active');
        });
        element.nextElementSibling.classList.toggle('active');
      });
    });
  }

  /********************** TOGGLE CLASS ACTIVE FOOTER **********************/
  const h3 = document.querySelectorAll('#footer h3.showSmartphone');
  h3.forEach((element) => {
    element.addEventListener('click', () => {
      element.classList.toggle('active');
    });
  });

  /********************** LENIS SCROLL SMOOTH **********************/
  window.scrollHtml = new Lenis({
    element: document.querySelector('cart-drawer-items'),
  });

  function refreshSmooth(time) {
    window.scrollHtml.raf(time);
    requestAnimationFrame(refreshSmooth);
  }

  requestAnimationFrame(refreshSmooth);

  /********************** PARALLAX **********************/
  new simpleParallax(document.querySelectorAll('.parallaxUpFixed:not(.onlyDesktop)'), {
    delay: 0.2,
    orientation: 'up',
    scale: 1.2,
    transition: 'cubic-bezier(0,0,0,1)',
    overflow: false,
  });

  new simpleParallax(document.querySelectorAll('.parallaxDownFixed:not(.onlyDesktop)'), {
    delay: 0.2,
    orientation: 'down',
    scale: 1.2,
    transition: 'cubic-bezier(0,0,0,1)',
    overflow: false,
  });

  new simpleParallax(document.querySelectorAll('.parallaxUp:not(.onlyDesktop)'), {
    delay: 0.2,
    orientation: 'up',
    scale: 1.2,
    transition: 'cubic-bezier(0,0,0,1)',
    overflow: true,
  });

  new simpleParallax(document.querySelectorAll('.parallaxDown:not(.onlyDesktop)'), {
    delay: 0.2,
    orientation: 'down',
    scale: 1.2,
    transition: 'cubic-bezier(0,0,0,1)',
    overflow: true,
  });

  new simpleParallax(document.querySelectorAll('.parallaxDownX2:not(.onlyDesktop)'), {
    delay: 0.4,
    orientation: 'down',
    scale: 1.6,
    transition: 'cubic-bezier(0,0,0,1)',
    overflow: true,
  });

  /********************** FADE-IN A L'APPARITION DANS LE VIEWPORT **********************/
  const elements = document.querySelectorAll(
    'p:not(.notFadeIn), h2:not(.notFadeIn), h3:not(.notFadeIn), span:not(.notFadeIn), h1:not(.notFadeIn), .fadeIn, .btn:not(.notFadeIn), s:not(.notFadeIn), s:not(.notFadeIn), div:not(.notFadeIn)'
  );

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function handleScroll() {
    elements.forEach((element) => {
      const delay = element.getAttribute('data-delay');
      if (isElementInViewport(element)) {
        if (delay) {
          setTimeout(() => {
            element.classList.add('active-fade-in');
          }, delay);
        } else {
          element.classList.add('active-fade-in');
        }
      }
    });
  }

  handleScroll();

  window.addEventListener('scroll', handleScroll);
}

window.addEventListener('DOMContentLoaded', () => initializeScrollAnimationTrigger());

document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target));
